export const getCartRestaurant = state => {
  if (state.items.length === 0) {
    return null
  }
  return state.restaurant
}

export const getOrderDeliveryType = state => {
  if (state.items.length === 0) {
    return null
  }
  return state.orderDeliveryType
}

export const getOrderPostcode = state => {
  return state.orderPostcode
}

export const getCartItems = state => {
  return state.items
}

export const getCartSubAmount = state => {
  return state.items.reduce((subAmount, item) => {
    return subAmount + (item.product.price * item.quantity)
  }, 0)
}

export const getCartDeliveryAmount = state => {
  if (!state.orderPostcode || state.deliveryType !== 'hot_delivery') {
    return 0
  }

  if (getCartSubAmount(state) >= state.orderPostcode.hot_delivery_fee.zero_fee_min_order) {
    return 0
  }

  return state.orderPostcode.hot_delivery_fee.fee
}

export const getCartTotalAmount = state => {
  return getCartSubAmount(state) + getCartDeliveryAmount(state)
}



// WEBPACK FOOTER //
// ./src/vuex/modules/cart/getters.js